export default __webpack_public_path__ + "static/media/lds-logo_no.f3b5f94d1ef83b56.svg";